define.alias("shared/utils/focus", "media/utils/focus");